/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $flag from './_flag'

var pageName: string = null
var pagePrefix: string = null

export function init($pageName, $pagePrefix): void {
    pageName = $pageName
    pagePrefix = $pagePrefix

    $flag.bindToggleFlagEvents($('.' + pageName + ' .' + pagePrefix + '-flags'))
}
